export const REQUEST_API_URL = {
  // USER REQUEST SECTION
  USER_REQUEST: 'business/pending-user-business',
  APPROVE_REJECT_USER_REQUEST: 'business/approve-reject-user-business',
  LEAVE_REQUEST: 'employee-leave/paging',
  LEAVE_REQUEST_ALL: 'employee-leave/export',
  APPROVE_REJECT_LEAVE_REQUEST: 'employee-leave/approve-reject',
  LEAVE_BY_ID: 'employee-leave/{{employee_leave_id}}',
  OPEN_REQUEST_PAGING: 'shift-open-request/paging',
  SHIFT_SWAP_REQUEST_PAGING: 'shift-swap-request/paging',
  OPEN_REQUEST_EXPORT: 'shift-open-request/export',
  SHIFT_SWAP_REQUEST_EXPORT: 'shift-swap-request/export'
 };
